import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    backgroundimage = "backgroundimage",
    image = "image",
    heading = "heading",
    title = "title",
    description = "description",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.heading]: string;
        [fields.title]: string;
        [fields.description]: string;
    };
}

export interface CENContactUsBanner {
    quoteWrapper?: InjectableCss;
    heading?: InjectableCss;
    quoteImageWrapper?: InjectableCss;
    quoteAuthorWrapper?: InjectableCss;
    quoteDesignationWrapper?: InjectableCss;
    title?: InjectableCss;
    description?: InjectableCss;
}

export const CENcontactUsBanner: CENContactUsBanner = {
    quoteWrapper: {
        css: css`
            display: flex;
            margin: 33px 48px 21px 32px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin: 33px 15px 21px 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    heading: {
        css: css`
            font-weight: 600;
            font-size: 18px;
            margin-top: 18px !important;
            margin-bottom: 2px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    title: {
        css: css`
            font-weight: 600;
            font-size: 14px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    description: {
        css: css`
            font-weight: 400;
            font-size: 16px;
            margin-top: 1px;
            margin-bottom: 22px !important;
        `,
    },
    quoteImageWrapper: {
        css: css`
            margin-right: 6px;
            img {
                width: 63px;
                height: auto;
            }

        `,
    },
};

const styles = CENcontactUsBanner;
type Props = WidgetProps;

export const CENContactUsBanner: FC<Props> = ({ fields }) => {
    const backgroundStyle = `background-image: url(${fields.backgroundimage});`;

    const wrapper = {
        css: css`
            margin-top: 40px !important;
            margin-bottom: 87px !important;
            font-size: ${TYPOGRAPHY.size.base} !important;
            width: auto;
            height: auto;
            margin: auto;
            display: flex;
            align-items: center;
            flex-direction: column;
            ${backgroundStyle};
            background-size: 100% 100% !important;
            background-position: center !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        width: auto;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    };
    return (
        <StyledWrapper {...wrapper}>
            <StyledWrapper {...styles.quoteWrapper}>
                <StyledWrapper {...styles.quoteImageWrapper}>
                    <Img className="CENImg" src={fields.image} altText={fields.heading} loading="lazy" />
                </StyledWrapper>
                <StyledWrapper>
                    <Typography variant="h5" {...styles.heading}>
                        {translate("{0}",fields.heading)}
                    </Typography>
                    <Typography variant="h6" {...styles.title}>
                        {fields.title}
                    </Typography>
                    <Typography variant="h6" {...styles.description}>
                        {fields.description}
                    </Typography>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const ContactUsBanner: WidgetModule = {
    component: CENContactUsBanner,
    definition: {
        group: "Basic",
        displayName: "CENcontactUs",
        fieldDefinitions: [
            {
                name: fields.backgroundimage,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Background Image",
            },
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Quote Image",
            },
            {
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.description,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default ContactUsBanner;
